<template>
  <NuxtLink
      v-if="data.item"
      class="tag-button"
      :to="`/${data.collection.split('_page')[0]}/${joinSlugId(data.item)}/`"
  >
    {{ sanitizedTitle }}
    <AppIconLoader name="arrowRight" variant="extra-small" aria-hidden="true" class="tag-button__icon"/>
  </NuxtLink>
</template>

<script setup lang="ts">
import {TTag} from '~/types/other-types'
import {computed} from "vue";
import {sanitizeMarkedHeading} from "~/utils/data-transformers";
import {joinSlugId} from "~/utils/slug-id";

const props = defineProps<{
  data: TTag,
}>()

const sanitizedTitle = computed(() => {
  return sanitizeMarkedHeading(props.data.item?.title)
})
</script>

<style scoped lang="postcss">
.tag-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 55px;
  border-width: 3px;
  border-color: var(--color-blue-aqua);
  background-color: var(--color-blue-aqua);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  color: var(--color-blue-prussian);
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }

  &:focus-visible {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }

  &__icon {
    flex-shrink: 0;
  }
}
</style>
